import { withDependencies } from '@wix/thunderbolt-ioc'
import type { ComponentWillMount, ViewerComponent } from 'feature-components'
import type { Experiments } from '@wix/thunderbolt-symbols'
import { ExperimentsSymbol } from '@wix/thunderbolt-symbols'
import type { IAudioPlaybackState } from './types'
import { AudioPlaybackStateSymbol } from './symbols'

export const AudioPlayerWillMount = withDependencies(
	[AudioPlaybackStateSymbol, ExperimentsSymbol],
	(audioPlaybackState: IAudioPlaybackState, experiments: Experiments): ComponentWillMount<ViewerComponent> => ({
		componentTypes: ['MusicPlayer', 'SingleAudioPlayer'],
		componentWillMount: (comp) => {
			if (!experiments['specs.thunderbolt.blockMpaNavigationOnAudioPlayback']) {
				return
			}
			const existingOnPlay = (comp.getProps() as Record<string, any>)?.onPlay
			comp.updateProps({
				onPlay: (...args: Array<unknown>) => {
					existingOnPlay?.(...args)
					audioPlaybackState.markPlayed()
				},
			})
		},
	})
)
